import { renderForCriticalMoment } from "../dashHelper";
import csatDonante from "./staticDashboards/csatDonante";
import csatPacientes from "./staticDashboards/csatPacientes";
import expHospitalizacion from "./staticDashboards/expHospitalizacion";
import general from "./staticDashboards/general";
import servClinicos from "./staticDashboards/servClinicos";
import servDiagCidyt from "./staticDashboards/servDiagCidyt";
import servEndoscopia from "./staticDashboards/servEndoscopia";
import servLaboratorio from "./staticDashboards/servLaboratorio";
import servNeurofisiologia from "./staticDashboards/servNeurofisiologia";
import servRadioterapia from "./staticDashboards/servRadioterapia";
import servRehabilitacion from "./staticDashboards/servRehabilitacion";

export default {
  title: 'Default Dashboard',
  description: 'Dashboard de perfil Default',
  backgroundClassName: (filters) => 'epsilon-hero-bg',
  widgets: (filters: FiltersUI, filtersData: Record<string, any>) => [
      ...general.widgets(filters, filtersData)
        .map((wdg) => ({
          ...wdg,
          render: (filters: FiltersUI) => renderForCriticalMoment(filters, [29]),
        })),
      ...expHospitalizacion.widgets(filters, filtersData)
        .map((wdg) => ({
          ...wdg,
          render: (filters: FiltersUI) => renderForCriticalMoment(filters, [10251]),
        })),
      /*
        ...csatDonante.widgets(filters, filtersData)
        .map((wdg) => ({
          ...wdg,
          render: (filters: FiltersUI) => renderForCriticalMoment(filters, [10252]),
          })),
      ...csatPacientes.widgets(filters, filtersData)
        .map((wdg) => ({
          ...wdg,
          render: (filters: FiltersUI) => renderForCriticalMoment(filters, [10254]),
        })),
      ...bsanSatReferencia.widgets(filters, filtersData)
        .map((wdg) => ({
          ...wdg,
          render: (filters: FiltersUI) => renderForCriticalMoment(filters, [10255]),
        })),
      */
      ...servNeurofisiologia.widgets(filters, filtersData)
        .map((wdg) => ({
          ...wdg,
          render: (filters: FiltersUI) => renderForCriticalMoment(filters, [10256, 12152, 12153]),
        })),
      ...servClinicos.widgets(filters, filtersData)
        .map((wdg) => ({
          ...wdg,
          render: (filters: FiltersUI) => renderForCriticalMoment(filters, [10257, 12101, 12151]),
        })),
      ...servEndoscopia.widgets(filters, filtersData)
        .map((wdg) => ({
          ...wdg,
          render: (filters: FiltersUI) => renderForCriticalMoment(filters, [10258]),
        })),
      ...servRehabilitacion.widgets(filters, filtersData)
        .map((wdg) => ({
          ...wdg,
          render: (filters: FiltersUI) => renderForCriticalMoment(filters, [10259]),
        })),
      ...servLaboratorio.widgets(filters, filtersData)
        .map((wdg) => ({
          ...wdg,
          render: (filters: FiltersUI) => renderForCriticalMoment(filters, [10260]),
        })),
      ...servRadioterapia.widgets(filters, filtersData)
        .map((wdg) => ({
          ...wdg,
          render: (filters: FiltersUI) => renderForCriticalMoment(filters, [10262]),
          })),
      ...servDiagCidyt.widgets(filters, filtersData)
        .map((wdg) => ({
          ...wdg,
          render: (filters: FiltersUI) => renderForCriticalMoment(filters, [10263]),
        })),        
    ],
} as DasboardConfig
